if (navigator.userAgent.indexOf('iPhone') > -1) {
  document.querySelector('[name=viewport]').setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex]:not([tabindex^=\'-\']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector('.quantity__button[name=\'minus\']');
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector('.quantity__button[name=\'plus\']');
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.productColumn = this.closest('.product__column-sticky');
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      if (this.productColumn != null) {
        this.productColumn.classList.add('off-header');
      }
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    //If accordions in drawer open first
    this.mainDetailsToggle.querySelectorAll('.drawer__inner details summary').forEach((details, index) => {
      if (index == 0) {
        details.click();
        console.log('click accordion');
      }
    });
  }

	close() {
		this.mainDetailsToggle.classList.remove('menu-opening');
    if (this.productColumn != null) {
      this.productColumn.classList.remove('off-header');
    }
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');

      if (details.querySelector('.icon-plus')) {
        details.querySelector('.icon-plus').style.display = 'block';
      }
      if (details.querySelector('.icon-minus')) {
        details.querySelector('.icon-minus').style.display = 'none';
      }
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
	}

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    if (this.productColumn != null) {
      this.productColumn.classList.remove('off-header');
    }
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');

      //If accordions in drawer toggle icons
      if (details.querySelector('.icon-plus')) {
        details.querySelector('.icon-plus').style.display = 'block';
      }
      if (details.querySelector('.icon-minus')) {
        details.querySelector('.icon-minus').style.display = 'none';
      }
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.paginationBullets = this.querySelector('.swiper-pagination');

    if (!this.slider || !this.nextButton) return;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));


  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    if (this.paginationBullets != null) {
      this.createPaginationBullets(); // Ajoutez cette ligne pour créer les balles de pagination
    }
    this.update();


  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  createPaginationBullets() {
    if (this.paginationBullets.querySelectorAll('.swiper-pagination-bullet').length < this.totalPages) {
      for (let i = 0; i < this.totalPages; i++) {
        const bullet = document.createElement('div');
        bullet.classList.add('swiper-pagination-bullet');
        if (i == 0) {
          bullet.classList.add('active');
        }
        bullet.dataset.page = i + 1;
        bullet.addEventListener('click', this.goToPage.bind(this));
        if (this.paginationBullets != null) {
          this.paginationBullets.appendChild(bullet);
        }
      }
    }

  }

  updatePaginationBullets() {
    if (this.paginationBullets != null) {
      const bullets = this.paginationBullets.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach(bullet => bullet.classList.remove('active'));
      if (bullets[this.currentPage - 1]) {
        bullets[this.currentPage - 1].classList.add('active');
      }
    }
  }

  goToPage(event) {
    const targetPage = parseInt(event.currentTarget.dataset.page, 10);
    const targetScrollPosition = (targetPage - 1) * this.sliderItemOffset;
    this.slider.scrollTo({
      left: targetScrollPosition,
      behavior: 'smooth'
    });
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (this.sliderItems[this.currentPage - 1] != null && this.sliderItems[this.currentPage - 1].classList.contains('swiper-packshot')) {
      this.closest('slider-component').classList.add('is-image-packshot');
    } else {
      this.closest('slider-component').classList.remove('is-image-packshot');
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    if (this.paginationBullets != null) {
      this.updatePaginationBullets();
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        console.log('addButtonUpdated');
        console.log(addButtonUpdated);
        // this.toggleAddButton(
        //   addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
        //   window.variantStringsvariantStrings.soldOut
        // );

        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
        if (!addButton) return;
        addButton.parentNode.insertBefore(addButtonUpdated, addButton.nextSibling);
        addButton.remove();

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


if (!customElements.get('component-countdown')) {
  customElements.define(
    'component-countdown',
    class Countdown extends HTMLElement {
      // static observedAttributes = ['date', 'time'];

      constructor() {
        super();
        this.elements = {
          days: this.querySelector('.days'),
          hours: this.querySelector('.hours'),
          minutes: this.querySelector('.minutes'),
          seconds: this.querySelector('.seconds')
        };
        this.update = this.update.bind(this);
        this.initTimer = this.initTimer.bind(this);
      }

      connectedCallback() {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'timer');
        if (!this.hasAttribute('aria-live')) this.setAttribute('aria-live', 'polite');
        this.update();
      }

      initTimer() {
        const unites = {
          second: 1000,
          minute: 1000 * 60,
          hour: 1000 * 60 * 60,
          day: 1000 * 60 * 60 * 24
        };

        const currentDate = new Date().getTime();
        const endDate = new Date(`${this.date}T${this.time}`).getTime();

        const timeDiffrence = Math.abs(endDate - currentDate);

        if (!timeDiffrence) {
          this.dispatchEvent(
            new Event('ended', { bubbles: true, composed: true }));
          clearInterval(this.interval);
        }
        ;

        this.timeLeft = [Math.floor(timeDiffrence / unites.day),
          Math.floor((timeDiffrence % unites.day) / unites.hour),
          Math.floor((timeDiffrence % unites.hour) / unites.minute),
          Math.floor((timeDiffrence % unites.minute) / unites.second)];
      }

      update() {
        const libelle = ['j', 'h', 'm', 's'];
        this.interval = setInterval(() => {
          this.initTimer();
          Object.values(this.elements).forEach((element, index) => {
            element.innerText = ('0' + this.timeLeft[index]).slice(-2) + libelle[index];
          });
        }, 0);
      }

      get time() {
        return this.getAttribute('time');
      }

      get date() {
        return this.getAttribute('date');
      }
    }
  );
}
;


if (!customElements.get('klaviyo-form')) {
  customElements.define(
    'klaviyo-form',
    class KlaviyoForm extends HTMLElement {

      constructor() {
        super();

        const selectors = {
          klaviyoListId: '[data-klaviyo-list-id]',
          klaviyoPropertiesKey: '[data-klaviyo-properties-key]',
          klaviyoPropertiesValue: '[data-klaviyo-properties-value]',
          klaviyoInput: '[data-klaviyo-input]',
          klaviyoSubmit: '[data-klaviyo-submit]',
          klaviyoSubmitSuccess: '[data-klaviyo-success]',
          klaviyoSubmitError: '[data-klaviyo-error]'
        };

        this.selectors = selectors;
        this.klaviyoSubmit = this.querySelector(selectors.klaviyoSubmit);
        this.klaviyoSubmitSuccess = this.querySelector(selectors.klaviyoSubmitSuccess);
        this.klaviyoSubmitError = this.querySelector(selectors.klaviyoSubmitError);
        this.klaviyoInput = this.querySelector(selectors.klaviyoInput);
        this.klaviyoSubmit = this.querySelector(selectors.klaviyoSubmit);

        if (!this.klaviyoSubmit) return;
        this.klaviyoSubmit.addEventListener('click', (event) => {
          this.sendForm();
        });
      }

      sendForm() {
        const klaviyoListId = this.dataset.klaviyoListId;
        const klaviyoPropertiesKey = this.dataset.klaviyoPropertiesKey;
        const klaviyoPropertiesValue = this.dataset.klaviyoPropertiesValue;
        const klaviyoInput = this.querySelector(this.selectors.klaviyoInput).value;

        if (klaviyoInput != null) {
          if (this.isValidEmail(klaviyoInput)) {
            const klaviyoData = {
              'properties_key': klaviyoPropertiesKey,
              'properties_value': klaviyoPropertiesValue,
              'klaviyo_list_id': klaviyoListId,
              'klaviyo_email': klaviyoInput
            };

            fetch('https://hook.eu1.make.com/w63uxxvnf022biuftxns5nwb296sihne', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(klaviyoData)
            })
              .then(response => {
                console.log(response);
                if (this.klaviyoSubmitSuccess != null) {
                  this.klaviyoSubmitSuccess.classList.add('active');
                  this.klaviyoInput.classList.add('hide');
                  this.klaviyoSubmit.classList.add('hide');
                }
              })
              .catch((error) => {
                console.error('Error:', error);
                if (this.klaviyoSubmitError != null) {
                  this.klaviyoSubmitError.classList.add('active');
                }
              });
          }
        }
      }

      isValidEmail(email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }


    }
  );
}
;

if (!customElements.get('add-to-cart-inline')) {
  customElements.define(
    'add-to-cart-inline',
    class AddToCartInline extends HTMLElement {

      constructor() {
        super();

        this.addEventListener('click', async (event) => {

          const preorderContainer = document.querySelector('preorder-only-container');
          if (preorderContainer != null) {
            const popupPreorderOnly = await preorderContainer.checkPreorderOnly(this);

            if (!popupPreorderOnly) return false;
          }

          this.addToCart();
        });
      }

      addToCart() {
        const productId = this.dataset.productId;
        const variantId = this.dataset.variantId;
        const quantity = this.dataset.quantity;
        const event = this.dataset.event;

        let properties = {};
        if (this.dataset.propertiesTitle !== undefined) {
          properties["_title"] = this.dataset.propertiesTitle;
        }
        if (this.dataset.propertiesSubtitle !== undefined) {
          properties["_subtitle"] = this.dataset.propertiesSubtitle;
        }
        if (this.dataset.propertiesStockSource !== undefined) {
          properties["_stock_source"] = this.dataset.propertiesStockSource;
        }
        if (this.dataset.propertiesPrecodate !== undefined) {
          properties["_preco"] = this.dataset.propertiesPrecodate;
          properties["_only-preco"] = "Pre-order only";
        }

        if (variantId != null) {
          const data = {
            "id": variantId,
            "quantity": quantity,
            "properties": properties
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then((data) => {
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      }


    }
  );
}
;

// Helpers

const setAllToMaxHeight = (className) => {
  var elements = document.querySelectorAll(className);
  var arrayLength = elements.length;
  var heights = [];

  for (var i = 0; i < arrayLength; i++) {
    heights.push(elements[i].offsetHeight);
  }

  function getHighest() {
    return Math.max(...heights);
  }

  var tallest = getHighest();

  for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = tallest + 'px';
  }
};


// filters-container
customElements.define(
  'filters-container',
  class FiltersContainer extends HTMLElement {
    constructor() {
      super();

      this.filterButtons = this.querySelectorAll('[data-toggle-filter]');
      this.filterButtonDesktop = this.querySelector('#filterButton');
      this.filterContent = this.querySelector('[data-filter-content]');

      this.isOpen = false;

      var self = this;
      this.filterButtons.forEach((button) =>
        button.addEventListener('click', () => {
          self.filterButtonDesktop.classList.toggle('open');
          self.filterContent.classList.toggle('open');
          if (this.isOpen) {
            this.filterContent.style.maxHeight = '0';
          } else {
            // Calculate the height of the content
            const contentHeight = this.filterContent.scrollHeight + 'px';
            this.filterContent.style.maxHeight = contentHeight;
          }

          this.isOpen = !this.isOpen;
        })
      );
    }
  }
);
// filters-container
customElements.define(
  'filters-accordions-mobile',
  class FiltersAccordionsMobile extends HTMLElement {
    constructor() {
      super();

      this.accordionsTrigger = this.querySelectorAll('[data-filters-accordions-mobile-trigger]');

      this.isOpen = false;

      var self = this;
      this.accordionsTrigger.forEach((button) =>
        button.addEventListener('click', (e) => {
          const accordionsContent = button.parentElement.querySelector('[data-filters-accordions-mobile-content]');
          button.classList.toggle('open');
          if (self.isOpen) {
            accordionsContent.style.maxHeight = '0';
            accordionsContent.style.marginTop = '0';
          } else {
            // Calculate the height of the content
            const contentHeight = accordionsContent.scrollHeight + 'px';
            accordionsContent.style.maxHeight = contentHeight;
            accordionsContent.style.marginTop = '10px';
          }

          self.isOpen = !self.isOpen;
        })
      );
    }
  }
);


//Account drawer
var accountDrawer = function() {

  // var domain = Shopify.shop;
  var domain = 'balzac-paris.myshopify.com';

  var context = {
    userMail: false,
    routeUrl: 'https://8d8m8hkpo1.execute-api.eu-west-1.amazonaws.com/prod/' + domain + '/customers/search',
    finalStateClass: 'account-drawer--final-state',
    storefrontApiKey: 'fc94ea14b161577c8eaf6c269dcfeab0',
    shopUrl: domain
  };


  var selectors = {
    accountLoader: '[data-account-loader]',

    errors: '[data-account-error]',

    accountContainer: '[data-account-container]',
    accountDrawer: '[data-account-drawer]',
    accountState: '[data-account-state]',

    emailTemplate: '[data-email-template]',
    emailInput: '[data-email-input]',
    emailButton: '[data-email-button]',

    registerTemplate: '[data-register-template]',
    registerForm: '[data-register-form]',
    registerMail: '[data-register-mail]',
    registerPassword: '[data-register-password]',
    registerPasswordMessage: '[data-register-password-message]',
    registerPasswordToggle: '[data-register-password-toggle]',
    registerAcceptTerms: '[data-register-accept-terms]',
    registerConfirmation: '[data-register-confirmation]',
    registerButton: '[data-register-button]',
    registerPhone: '[data-register-phone]',

    signinSuccess: '[data-signin-success]',
    signinTemplate: '[data-signin-template]',
    signinForm: '[data-signin-form]',
    signinFormError: '[data-signin-error]',
    signinForgot: '[data-signin-forgot]',
    signinMail: '[data-signin-mail]',
    signinButton: '[data-signin-button]',
    signinPassword: '[data-signin-password]',
    signinPasswordToggle: '[data-signin-password-toggle]',

    forgotTemplate: '[data-forgot-template]',
    forgotMail: '[data-forgot-mail]',
    forgotButton: '[data-forgot-button]',

    activateTemplate: '[data-activate-template]',
    activateMail: '[data-activate-mail]',
    activateButton: '[data-activate-button]',

    pendingTemplate: '[data-pending-template]',

    oxiHideContainer: '[data-oxi-hide-container]',
    oxiShowContainer: '[data-oxi-show-container]',
    oxiContainer: '[data-oxi-content]',

    back: '[data-account-back]'

  };


  // Select the element with the class .drawer__component.drawer__account-details
  const targetElement = document.querySelector('.drawer__component.drawer__account [data-panel-section]');

  // Create a new MutationObserver instance
  const observer = new MutationObserver(function(mutationsList) {
    // Check if the class .menu-opening has been added or removed from the target element
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const classList = targetElement.classList;
        if (classList.contains('active')) {
          console.log('Class .menu-opening has been added to the element');
          openPopup();
        } else {
          console.log("Class .menu-opening has been removed from the element");
          closePopup()
        }
      }
    }
  });

  // Start observing changes to the attributes of the target element
  observer.observe(targetElement, { attributes: true });


  function openPopup() {


    var elem = document.querySelector(selectors.accountContainer);
    elem.innerHTML = '';

    var clone = document.querySelector(selectors.signinTemplate).cloneNode(true);
    clone.classList.remove('hide');

    elem.appendChild(clone);

    document.querySelector(selectors.accountDrawer).style.display = 'block';
    initPopupHandlers();
    initEmailPopup();
    initSigninPopup();
    initBackButtons();

    // if wrong password
    if (getCookie('tryLogin')) {
      changePopup('signin');
      if (document.querySelector(selectors.signinFormError) != null) {
        document.querySelector(selectors.signinFormError).style.display = 'block';
        deleteCookie('tryLogin');
      }
    }
  }

  function closePopup() {
    var oxiContent = document.querySelector(selectors.oxiContainer);
    oxiContent.parentNode.removeChild(oxiContent);
    document.querySelector(selectors.oxiHideContainer).appendChild(oxiContent);
    document.querySelector(selectors.accountDrawer).style.display = 'none';
  }


  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function showLoader() {
    document.querySelector(selectors.accountLoader).style.display = 'block';
  }

  function hideLoader() {
    document.querySelector(selectors.accountLoader).style.display = 'none';
  }

  function loginUser(email, password) {
    setCookie('login', true, 0.1);
    setCookie('tryLogin', true, 0.1);

    // Create a form synamically
    var form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', window.Shopify.routes.root + 'account/login');
    form.id = 'customer_login';

    var emailInput = document.createElement('input');
    emailInput.setAttribute('type', 'email');
    emailInput.setAttribute('name', 'customer[email]');
    emailInput.value = email;

    var challengeInput = document.createElement('input');
    challengeInput.setAttribute('type', 'hidden');
    challengeInput.setAttribute('name', 'challenge');
    challengeInput.value = false;

    var passwordInput = document.createElement('input');
    passwordInput.setAttribute('type', 'password');
    passwordInput.setAttribute('name', 'customer[password]');
    passwordInput.value = password;

    form.appendChild(emailInput);
    form.appendChild(challengeInput);
    form.appendChild(passwordInput);

    //it has to be added somewhere into the <body>
    document.body.appendChild(form).submit();
  }

  function recoverPassword(email) {
    const recoverQuery = `mutation customerRecover($email: String!) {
      customerRecover(email: $email) {
        customerUserErrors {
          code
          field
          message
        }
      }
    }`;
    const params = {
      query: recoverQuery,
      variables: {
        email: email
      }
    };
    const optionsQuery = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': context.storefrontApiKey
      },
      body: JSON.stringify(params)
    };

    return fetch(`https://` + domain + `/api/2024-10/graphql`, optionsQuery)
      .then(res => res.json());
  }

  function registerUser(customer) {
    const registerQuery = `mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        id
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
  `;

    const params = {
      query: registerQuery,
      variables: {
        input: {
          acceptsMarketing: customer.accepts_marketing === 'on' ? true : false,
          email: customer.email,
          firstName: customer.first_name,
          lastName: customer.last_name,
          password: customer.password,
        }
      }
    };


    if (customer.telephone.length > document.querySelector('#country-select').value.length) {
      params.variables.input.phone = customer.telephone;
    }


    const optionsQuery = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': context.storefrontApiKey,
				'Accept-Language': `${document.documentElement.lang}`
      },
      body: JSON.stringify(params)
    };

    return fetch(`https://` + domain + `/api/2023-10/graphql`, optionsQuery)
      .then(res => res.json()) // assurez-vous que la réponse est au format JSON
      .then(response => {
        console.log(response);
        document.querySelector('[data-error-register]').childNodes.forEach(node => {
          node.remove();
        });

        if (response.errors) {
          response.errors.forEach(error => {
            const li = document.createElement('li');
            li.innerHTML = error.message;
            document.querySelector('[data-error-register]').appendChild(li);
          });
          return Promise.reject('Erreurs de création utilisateur');
        } else if (response.data.customerCreate.customerUserErrors.length > 0) {
          response.data.customerCreate.customerUserErrors.forEach(error => {
            console.log(error);
            const li = document.createElement('li');
            li.innerHTML = error.message;
            document.querySelector('[data-error-register]').appendChild(li);
          });
          return Promise.reject('Erreurs de validation utilisateur');
        }

        if (response.data.customerCreate?.customer?.id != null) {
          return response;
        } else {
          return Promise.reject('Aucun identifiant utilisateur trouvé');
        }
      })
      .catch(error => {
        console.error('Erreur dans registerUser:', error);
        return Promise.reject(error);
      });
  }

  function validateEmail(email) {
    // console.log('Validate email ', email);
    context.userMail = email;
    showLoader();

    const params = {
      email: email
    };

    const optionsQuery = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(params)
    };

    fetch(context.routeUrl, optionsQuery)
      .then(function(response) {
        if (response.ok) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        hideLoader();
        // console.log(response)
        if (!response.data) {
          changePopup('register');
        } else {
          var state = response.data.state;
          if (state == 'enabled') {
            changePopup('signin');
            // if (response.data.properties.first_name) document.querySelector('[data-signin-firstname]').innerHTML = response.data.properties.first_name;
            // if (response.data.first_name) {
            //   var first_name = response.data.first_name;
            //   document.querySelector('[data-signin-firstName]').html(first_name);
            // }
          } else if (state == 'disabled') {
            changePopup('activate');
          } else if (state == 'pending' || state == 'invited' || state == 'declined') {
            var mail = context.userMail;
            activateAccount(mail);
            changePopup('pending');
          }
        }
      }).catch(function(err) {
      hideLoader();
      console.log('Something went wrong: ', err);
    });
  }

  function activateAccount(email) {
    console.log('ACTIVATE ACCOUNT');
    const registerQuery = `mutation customerCreate($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        customer {
          id
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
    `;

    const params = {
      query: registerQuery,
      variables: {
        input: {
          email: email,
          password: 'cabaiashop'
        }
      }
    };

    const optionsQuery = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': context.storefrontApiKey
      },
      body: JSON.stringify(params)
    };

    return fetch(`https://` + domain + `/api/2023-10/graphql`, optionsQuery)
      .then(res => res.json());
  }

  function verifyEmail(elementValue) {
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/;
    return emailPattern.test(elementValue);
  }

  function checkEmail(email, code) {
    if (verifyEmail(email)) {
      document.querySelector(selectors.emailButton).disabled = false;
      if (code == 'Enter') {
        validateEmail(email);
      }
    } else {
      document.querySelector(selectors.emailButton).disabled = true;
    }
  }

  function initEmailPopup() {
    var oxiContent = document.querySelector(selectors.oxiContainer);
    oxiContent.parentNode.removeChild(oxiContent);
    document.querySelector(selectors.oxiShowContainer).appendChild(oxiContent);

    var efficientFn = debounce(function(e) {
      checkEmail(this.value, e.key);
    }, 150);
    document.querySelector(selectors.emailInput).addEventListener('keyup', efficientFn);
    document.querySelector(selectors.emailButton).addEventListener('click', function() {
      if (verifyEmail(document.querySelector(selectors.emailInput).value)) {
        validateEmail(document.querySelector(selectors.emailInput).value);
      }
    });
  }

  function isValidPassword(password) {
    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    return strongRegex.test(password);
  }

  function setRegisterButton(accept_terms, inputs_required_completed) {
    console.log(accept_terms, inputs_required_completed);
    if (accept_terms && inputs_required_completed) {
      document.querySelector(selectors.registerButton).disabled = false;
    } else {
      document.querySelector(selectors.registerButton).disabled = true;
    }
  }

  function initBackButtons() {
    document.querySelectorAll(selectors.back).forEach((button) => {
      button.addEventListener('click', function() {
        changePopup('signin');
      });
    });
  }

  function initRegisterPopup() {

    var accept_terms = false;
    var inputs_required_completed = false;

    // 2
    if (document.querySelector('[type="date"]').type != 'date') {
      document.querySelector('[type="date"]').datepicker({
        dateFormat: 'mm/dd/yy',
        changeMonth: true,
        changeYear: true,
        yearRange: '-100y:c+nn',
        maxDate: '-1d'
      });
    }

    initBackButtons();

    if (document.querySelector(selectors.registerPasswordToggle) != null) {
      document.querySelector(selectors.registerPasswordToggle).addEventListener('click', function() {
        var passwordInput = document.querySelector(selectors.registerPassword);
        if (passwordInput.type === 'password') {
          passwordInput.type = 'text';
        } else {
          passwordInput.type = 'password';
        }
      });
    }

    if (document.querySelector(selectors.registerPhone) != null) {
      document.querySelector(selectors.registerPhone).value = document.querySelector('#country-select').value;
      document.querySelector('#country-select').addEventListener('change', function() {
        document.querySelector(selectors.registerPhone).value = this.value;
      });
    }
    // 4
    var inputTextAll = document.querySelectorAll(selectors.accountContainer + ' ' + selectors.registerForm + ' .field__input');

    function updateRegisterButton() {
      var allValid = true;

      inputTextAll.forEach(function(input) {

        if (input.value === '') {
          allValid = false;
          console.log(allValid, '1');
        }
      });

      var emailInput = document.querySelector('[data-register-mail]');
      if (emailInput && !verifyEmail(emailInput.value)) {
        allValid = false;
        console.log(allValid, '2');
      }


      var passwordInput = document.querySelector('[data-register-password]');
      if (passwordInput && !isValidPassword(passwordInput.value)) {
        allValid = false;
      }


      inputs_required_completed = allValid;
      setRegisterButton(true, inputs_required_completed);
    }

    inputTextAll.forEach(function(input) {
      input.addEventListener('keyup', function(e) {
        if (e.target.hasAttribute('data-register-mail') && verifyEmail(e.target.value)) {
          updateRegisterButton();
        }

        if(e.target.hasAttribute('data-register-phone')) {
          if (e.target.value.length > document.querySelector('#country-select').value.length) {
            document.querySelector('[data-register-newsletter-sms]').disabled = false;
            document.querySelector('[data-register-newsletter-sms]').closest('.account-drawer__field-wrapper').classList.remove('hidden');
          }
          else {
            document.querySelector('[data-register-newsletter-sms]').disabled = true;
            document.querySelector('[data-register-newsletter-sms]').closest('.account-drawer__field-wrapper').classList.add('hidden');
          }
        }

        if (e.target.hasAttribute('data-register-password')) {
          if (isValidPassword(e.target.value)) {
            updateRegisterButton();

            if (e.key === 13) {
              document.querySelector(selectors.registerButton).click();
              e.preventDefault();
            }

            var passwordMessage = document.querySelector(selectors.registerPasswordMessage);
            if (passwordMessage) {
              passwordMessage.classList.remove('account-drawer__field-error');
              passwordMessage.classList.add('account-drawer__field-success', 'active');
            }
          } else {
            updateRegisterButton();

            var passwordMessage = document.querySelector(selectors.registerPasswordMessage);
            if (passwordMessage) {
              passwordMessage.classList.remove('account-drawer__field-success');
              passwordMessage.classList.add('account-drawer__field-error', 'active');
            }
          }
        }

        if (e.key === 13 && e.target.hasAttribute('data-register-password') && isValidPassword(e.target.value)) {
          document.querySelector(selectors.registerButton).click();
          e.preventDefault();
        }
      });
    });

    updateRegisterButton();


    // 5
    document.querySelector(selectors.registerForm).addEventListener('submit', async function(e) {
      e.preventDefault();

      showLoader();
      var newCustomer = document.querySelector(selectors.accountContainer + ' ' + selectors.registerForm);

      const formEntries = new FormData(newCustomer).entries();
      var formJson = Object.assign(...Array.from(formEntries, ([x, y]) => ({ [x]: y })));
      console.log(formJson);
      return registerUser(formJson).then(function(response) {
        if (formJson.language != null || formJson.birthdate || formJson.accepts_sms) {
          var customerID = response.data.customerCreate.customer.id.replace('gid://shopify/Customer/', '');

          const form = {
            'email': formJson.email,
            'customer_id': customerID,
            'accepts_sms': formJson.accepts_sms ? formJson.accepts_sms : '',
            'language': formJson.language ? formJson.language : '',
            'birthdate': formJson.birthdate ? formJson.birthdate : ''
          };

          const url = 'https://hook.eu1.make.com/xjdxc5gzh9lae4e0x173y4pn48mixy9o';


          fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(form)
          })
            .then((response) => response.json())
            .then((data) => {
              console.log('ok');
              console.log(data);
            })
            .catch((error) => {
              console.log('error');
              console.log(error);
            });
        }
        loginUser(formJson.email, formJson.password);
      });
    });
  }

  function initSigninPopup() {
    var oxiContent = document.querySelector(selectors.oxiContainer);
    oxiContent.parentNode.removeChild(oxiContent);
    document.querySelector(selectors.oxiShowContainer).appendChild(oxiContent);
    if (context.userMail) document.querySelector(selectors.signinMail).value = context.userMail;
    document.querySelector(selectors.signinForgot).addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      changePopup('forgot');
    });
    var signInInputTextAll = document.querySelectorAll(selectors.accountDrawer + ' ' + selectors.signinForm);
    var registerButton = document.querySelectorAll(selectors.accountDrawer + ' ' + '[data-account-register]');

    registerButton?.forEach(el => {
      el.addEventListener('click', function() {
        changePopup('register');
      });
    });
    for (var i = 0; i < signInInputTextAll.length; i++) {
      var inputText = signInInputTextAll[i].querySelectorAll('.field__input');
      inputText.forEach(el => {

        if (el.value == null || el.value == undefined || el.value == '') {
          document.querySelector(selectors.signinButton).disabled = true;
          document.querySelector(selectors.signinButton).classList.add('button--disabled');
        } else {
          document.querySelector(selectors.signinButton).disabled = false;
          document.querySelector(selectors.signinButton).classList.remove('button--disabled');
        }

        el.addEventListener('keyup', function(event) {
          var isEmpty = false;
          if (!el.value || el.value == '') isEmpty = true;
          if (isEmpty) {
            document.querySelector(selectors.signinButton).disabled = true;
          } else {
            document.querySelector(selectors.signinButton).disabled = false;
            if (event.key == 'Enter') document.querySelector(selectors.signinButton).click();
          }
        });
      });
    }

    if (document.querySelector(selectors.signinPasswordToggle) != null) {
      document.querySelector(selectors.signinPasswordToggle).addEventListener('click', function() {
        var passwordInput = document.querySelector(selectors.signinPassword);
        if (passwordInput.type === 'password') {
          passwordInput.type = 'text';
        } else {
          passwordInput.type = 'password';
        }
      });
    }

    document.querySelector(selectors.signinButton).addEventListener('click', function() {
      showLoader();
      var password = document.querySelector(selectors.signinPassword).value;
      var email = document.querySelector(selectors.signinMail).value;
      setCookie('email', email, 0.1);
      return loginUser(email, password);
    });
  }

  function initForgotPopup() {
    if (context.userMail) document.querySelector(selectors.forgotMail).value = context.userMail;

    document.querySelector(selectors.forgotButton).addEventListener('click', async function() {
      showLoader();
      var email = document.querySelector(selectors.forgotMail).value;
      return recoverPassword(email)
        .then(function(response) {
          var errorHtml = null;
          if (!response || !response.data) return;
          if (response.data.customerCreate) {
            var errors = response.data.customerRecover.customerUserErrors;
          } else {
            var errors = response.data.errors;
          }
          if (errors && errors.length) {
            errorHtml = '';
            for (var i = 0; i < errors.length; i++) {
              errorHtml += errors[i].message + ' <br>';
            }
            document.querySelector(selectors.errors).html(errorHtml);
            document.querySelector(selectors.errors).show();
            hideLoader();
          } else {
            document.querySelector(selectors.accountState).classList.add(context.finalStateClass);
            hideLoader();
          }
        });
    });
  }

  function initActivatePopup() {
    if (context.userMail) document.querySelector(selectors.activateMail).value = context.userMail;

    document.querySelector(selectors.activateButton).addEventListener('click', async function() {
      showLoader();
      var email = document.querySelector(selectors.activateMail).value;
      console.log('Activate my account');
      return activateAccount(email)
        .then(function(response) {
          // TODO
          console.log('Response ', response);
          var errorHtml = null;
          if (response.data.customerCreate) {
            var errors = response.data.customerRecover;
          } else {
            var errors = response.data.errors;
          }
          hideLoader();
          if (errors && errors.length) {
            errorHtml = '';
            for (var i = 0; i < errors.length; i++) {
              errorHtml += errors[i].message + ' <br>';
            }
            document.querySelector(selectors.errors).innerHTML = errorHtml;
            document.querySelector(selectors.errors).style.display = 'block';
          } else {
            changePopup('pending');
          }
        });
    });
  }

  function initPopupHandlers() {
    initEmailPopup();
  }

  function changePopup(key) {

    var oxiContent = document.querySelector(selectors.oxiContainer);
    oxiContent.parentNode.removeChild(oxiContent);
    document.querySelector(selectors.oxiHideContainer).appendChild(oxiContent);

    var elem = document.querySelector(selectors.accountContainer);
    elem.innerHTML = '';

    if (key == 'register') {
      var clone = document.querySelector(selectors.registerTemplate).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
      initRegisterPopup();
    }
    if (key == 'signin') {
      var clone = document.querySelector(selectors.signinTemplate).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
      initSigninPopup();
    }
    if (key == 'email') {
      var clone = document.querySelector(selectors.emailTemplate).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
      initEmailPopup();
    }
    if (key == 'signinSuccess') {
      var clone = document.querySelector(selectors.signinSuccess).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
      initBackButtons();
    }
    if (key == 'forgot') {
      var clone = document.querySelector(selectors.forgotTemplate).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
      initForgotPopup();
      initBackButtons();
    }
    if (key == 'activate') {
      var clone = document.querySelector(selectors.activateTemplate).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
      initActivatePopup();
    }
    if (key == 'pending') {
      var clone = document.querySelector(selectors.pendingTemplate).cloneNode(true);
      clone.classList.remove('hide');
      elem.appendChild(clone);
    }
  }

  return accountDrawer;
};
accountDrawer();


class FairlyMadeTrigger extends HTMLElement {
  constructor() {
    super();

    this.fairlyMadePopup = document.querySelector('[data-fairly-made-popup]');
    this.fairlyMadePopupContent = document.querySelector('[data-fairly-made-popup-content]');
    this.fairlyMadePopupCloses = document.querySelectorAll('[data-fairly-made-popup-close]');

    this.addEventListener('click', () => {
      this.showModal();
    });

    this.fairlyMadePopupCloses.forEach((fClose) => {
      fClose.addEventListener('click', () => {
        this.closeModal();
      });
    });
  }

  showModal() {
    // Create and insert ifram content
    if (this.fairlyMadePopupContent !== null && this.fairlyMadePopupContent !== undefined) {
      const fairlyMadeContentUrl = this.fairlyMadePopupContent.getAttribute('data-fairly-made-popup-content');
      if (fairlyMadeContentUrl !== null && fairlyMadeContentUrl !== undefined && fairlyMadeContentUrl.length > 0) {
        const fairlyMadeContentHTML = `<iframe frameBorder="0" src="${fairlyMadeContentUrl}"></iframe>`;
        this.fairlyMadePopupContent.innerHTML = fairlyMadeContentHTML;
      }
    }

    // Show popup
    this.fairlyMadePopup?.classList.add('active');
  }

  closeModal() {
    this.fairlyMadePopup?.classList.remove('active');
  }

}

customElements.define('fairly-made-trigger', FairlyMadeTrigger);


class ImageWithTextText extends HTMLElement {
  constructor() {
    super();

    this.showMore = this.querySelector('[data-show-more]');
    this.visibleText = this.querySelector('.text-visible');
    this.updateInitialHeight();

    if (this.showMore != null) {
      if (this.visibleText.scrollHeight <= this.visibleText.offsetHeight) {
        this.showMore.style.display = 'none';
      } else {
        this.showMore.addEventListener('click', () => this.showText());
      }
    }
  }

  updateInitialHeight() {
    const initialHeight = this.visibleText.offsetHeight;
    this.style.setProperty('--truncate-height', `${initialHeight}px`);
  }

  showText() {
    this.visibleText.classList.remove('text-truncate');
    window.getComputedStyle(this.visibleText).getPropertyValue('height');
    this.visibleText.style.maxHeight = `${this.visibleText.scrollHeight}px`;
    this.showMore.style.display = 'none';
  }
}

customElements.define('image-with-text-text', ImageWithTextText);


class PopupSizeGuide extends HTMLElement {
  constructor() {
    super();

    this.sizeGuideOpen = this.querySelector('[data-size-guide-open]');
    this.sizeGuideClose = this.querySelectorAll('[data-size-guide-close]');
    this.sizeGuideContainer = this.querySelector('[data-size-guide]');
    this.header = document.querySelector('.section-header');

    if (this.sizeGuideOpen != null) {
      var self = this;
      this.sizeGuideOpen.addEventListener('click', function() {
        self.sizeGuideContainer.classList.remove('hide');
        self.header.style.zIndex = 5;
      });
    }

    if (this.sizeGuideOpen != null) {
      var self = this;
      this.sizeGuideClose.forEach((el) => {
        el.addEventListener('click', function() {
          self.sizeGuideContainer.classList.add('hide');
          self.header.style.zIndex = 10;
        });
      });
    }
  }
}

customElements.define('popup-size-guide', PopupSizeGuide);

